import type {
  CaseApiResponse,
  CaseDetailApiResponse,
  CheckApiResponse,
  CheckUpdateApiRequest,
} from '../../features/cases/cases.models';

/**
 * 審査対象一覧Mockデータ
 * プロジェクトIDに紐づく審査対象の一覧（api-server準拠のレスポンス形式）
 */
export const MOCK_CASES: Record<string, CaseApiResponse[]> = {
  // project-001 (直接雇用・正社員) の審査対象
  'project-001': [
    {
      publicId: 'case-001',
      projectId: 'project-001',
      employeeId: 'EMP001',
      employeeName: '山田 太郎',
      itemKey: 'EMP001_employment',
      displayName: '山田 太郎_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 1,
      reviewStatus: 'Complete',
      summaryFiles: 'ApprovedByHuman',
      summaryFields: 'ApprovedByHuman',
      summaryConsistencies: 'ApprovedByHuman',
      mark: null,
      memo: '',
      createdAt: '2025-01-14T10:00:00.000Z',
      updatedAt: '2025-01-15T10:00:00.000Z',
      updatedByUser: null,
    },
    // EMP001の仕訳審査アイテム（journal_entry、複数月）
    {
      publicId: 'case-001-je-04',
      projectId: 'project-001',
      employeeId: 'EMP001',
      employeeName: '山田 太郎',
      itemKey: 'EMP001_journal_entry_202504',
      displayName: '山田 太郎_仕訳_2025-04',
      reviewType: 'journal_entry',
      targetMonth: '202504',
      displayOrder: 2,
      reviewStatus: 'Complete',
      summaryFiles: 'ApprovedByHuman',
      summaryFields: 'ApprovedByHuman',
      summaryConsistencies: 'ApprovedByHuman',
      mark: null,
      memo: '',
      createdAt: '2025-01-14T10:00:00.000Z',
      updatedAt: '2025-01-15T10:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-001-je-05',
      projectId: 'project-001',
      employeeId: 'EMP001',
      employeeName: '山田 太郎',
      itemKey: 'EMP001_journal_entry_202505',
      displayName: '山田 太郎_仕訳_2025-05',
      reviewType: 'journal_entry',
      targetMonth: '202505',
      displayOrder: 3,
      reviewStatus: 'AiRejected',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-14T10:00:00.000Z',
      updatedAt: '2025-01-15T10:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-002',
      projectId: 'project-001',
      employeeId: 'EMP002',
      employeeName: '佐藤 花子',
      itemKey: 'EMP002_employment',
      displayName: '佐藤 花子_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 2,
      reviewStatus: 'AiApproved',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-14T09:30:00.000Z',
      updatedAt: '2025-01-15T09:30:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-003',
      projectId: 'project-001',
      employeeId: 'EMP003',
      employeeName: '鈴木 一郎',
      itemKey: 'EMP003_employment',
      displayName: '鈴木 一郎_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 3,
      reviewStatus: 'AiApproved',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-14T09:00:00.000Z',
      updatedAt: '2025-01-15T09:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-004',
      projectId: 'project-001',
      employeeId: 'EMP004',
      employeeName: '田中 美咲',
      itemKey: 'EMP004_employment',
      displayName: '田中 美咲_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 4,
      reviewStatus: 'Complete',
      summaryFiles: 'ApprovedByHuman',
      summaryFields: 'ApprovedByHuman',
      summaryConsistencies: 'ApprovedByHuman',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T16:00:00.000Z',
      updatedAt: '2025-01-14T16:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-005',
      projectId: 'project-001',
      employeeId: 'EMP005',
      employeeName: '高橋 健太',
      itemKey: 'EMP005_employment',
      displayName: '高橋 健太_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 5,
      reviewStatus: 'AiApproved',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T15:30:00.000Z',
      updatedAt: '2025-01-14T15:30:00.000Z',
      updatedByUser: null,
    },
  ],

  // project-002 (直接雇用・契約社員（有期）) の審査対象
  'project-002': [
    {
      publicId: 'case-006',
      projectId: 'project-002',
      employeeId: 'EMP006',
      employeeName: '渡辺 裕子',
      itemKey: 'EMP006_employment',
      displayName: '渡辺 裕子_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 1,
      reviewStatus: 'Complete',
      summaryFiles: 'ApprovedByHuman',
      summaryFields: 'ApprovedByHuman',
      summaryConsistencies: 'ApprovedByHuman',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T14:00:00.000Z',
      updatedAt: '2025-01-14T14:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-007',
      projectId: 'project-002',
      employeeId: 'EMP007',
      employeeName: '伊藤 達也',
      itemKey: 'EMP007_employment',
      displayName: '伊藤 達也_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 2,
      reviewStatus: 'AiRejected',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T13:00:00.000Z',
      updatedAt: '2025-01-14T13:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-008',
      projectId: 'project-002',
      employeeId: 'EMP008',
      employeeName: '中村 さくら',
      itemKey: 'EMP008_employment',
      displayName: '中村 さくら_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 3,
      reviewStatus: 'ChangeRequest',
      summaryFiles: 'Unapproved',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T12:00:00.000Z',
      updatedAt: '2025-01-14T12:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-009',
      projectId: 'project-002',
      employeeId: 'EMP009',
      employeeName: '小林 誠',
      itemKey: 'EMP009_employment',
      displayName: '小林 誠_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 4,
      reviewStatus: 'Unreviewed',
      summaryFiles: 'Unapproved',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T11:00:00.000Z',
      updatedAt: '2025-01-14T11:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-010',
      projectId: 'project-002',
      employeeId: 'EMP010',
      employeeName: '加藤 美紀',
      itemKey: 'EMP010_employment',
      displayName: '加藤 美紀_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 5,
      reviewStatus: 'AiApproved',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T10:00:00.000Z',
      updatedAt: '2025-01-14T10:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-011',
      projectId: 'project-002',
      employeeId: 'EMP011',
      employeeName: '吉田 浩二',
      itemKey: 'EMP011_employment',
      displayName: '吉田 浩二_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 6,
      reviewStatus: 'AiRejected',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T09:00:00.000Z',
      updatedAt: '2025-01-14T09:00:00.000Z',
      updatedByUser: null,
    },
  ],

  // project-003 (直接雇用・アルバイト) の審査対象
  'project-003': [
    {
      publicId: 'case-012',
      projectId: 'project-003',
      employeeId: 'EMP012',
      employeeName: '山本 由美',
      itemKey: 'EMP012_employment',
      displayName: '山本 由美_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 1,
      reviewStatus: 'Complete',
      summaryFiles: 'ApprovedByHuman',
      summaryFields: 'ApprovedByHuman',
      summaryConsistencies: 'ApprovedByHuman',
      mark: null,
      memo: '',
      createdAt: '2025-01-12T09:00:00.000Z',
      updatedAt: '2025-01-13T09:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-013',
      projectId: 'project-003',
      employeeId: 'EMP013',
      employeeName: '松本 隆',
      itemKey: 'EMP013_employment',
      displayName: '松本 隆_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 2,
      reviewStatus: 'AiApproved',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-12T08:30:00.000Z',
      updatedAt: '2025-01-13T08:30:00.000Z',
      updatedByUser: null,
    },
  ],

  // project-004 (間接雇用・出向者) の審査対象
  'project-004': [
    {
      publicId: 'case-014',
      projectId: 'project-004',
      employeeId: 'EMP014',
      employeeName: '井上 剛',
      itemKey: 'EMP014_employment',
      displayName: '井上 剛_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 1,
      reviewStatus: 'Unreviewed',
      summaryFiles: 'Unapproved',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-11T11:00:00.000Z',
      updatedAt: '2025-01-12T11:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-015',
      projectId: 'project-004',
      employeeId: 'EMP015',
      employeeName: '木村 愛',
      itemKey: 'EMP015_employment',
      displayName: '木村 愛_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 2,
      reviewStatus: 'Unreviewed',
      summaryFiles: 'Unapproved',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-11T10:30:00.000Z',
      updatedAt: '2025-01-12T10:30:00.000Z',
      updatedByUser: null,
    },
  ],

  // project-005 (直接雇用・正社員 - 君津事業所) の審査対象
  'project-005': [
    {
      publicId: 'case-016',
      projectId: 'project-005',
      employeeId: 'EMP016',
      employeeName: '斎藤 翔',
      itemKey: 'EMP016_employment',
      displayName: '斎藤 翔_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 1,
      reviewStatus: 'AiApproved',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'ApprovedByAI',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T09:30:00.000Z',
      updatedAt: '2025-01-14T09:30:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-017',
      projectId: 'project-005',
      employeeId: 'EMP017',
      employeeName: '清水 真由美',
      itemKey: 'EMP017_employment',
      displayName: '清水 真由美_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 2,
      reviewStatus: 'AiRejected',
      summaryFiles: 'ApprovedByAI',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'ApprovedByAI',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T09:00:00.000Z',
      updatedAt: '2025-01-14T09:00:00.000Z',
      updatedByUser: null,
    },
    {
      publicId: 'case-018',
      projectId: 'project-005',
      employeeId: 'EMP018',
      employeeName: '森田 大輔',
      itemKey: 'EMP018_employment',
      displayName: '森田 大輔_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 3,
      reviewStatus: 'Unreviewed',
      summaryFiles: 'Unapproved',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-13T08:30:00.000Z',
      updatedAt: '2025-01-14T08:30:00.000Z',
      updatedByUser: null,
    },
  ],

  // project-006 (直接雇用・契約社員（無期） - 君津事業所) の審査対象
  'project-006': [
    {
      publicId: 'case-019',
      projectId: 'project-006',
      employeeId: 'EMP019',
      employeeName: '池田 智子',
      itemKey: 'EMP019_employment',
      displayName: '池田 智子_雇用',
      reviewType: 'employment',
      targetMonth: null,
      displayOrder: 1,
      reviewStatus: 'Unreviewed',
      summaryFiles: 'Unapproved',
      summaryFields: 'Unapproved',
      summaryConsistencies: 'Unapproved',
      mark: null,
      memo: '',
      createdAt: '2025-01-09T14:00:00.000Z',
      updatedAt: '2025-01-10T14:00:00.000Z',
      updatedByUser: null,
    },
  ],
};

/**
 * チェックリストのMockデータストア（更新時に書き換えられる）
 * キー: `${projectId}:${caseId}`
 */
const MOCK_CHECK_LISTS: Partial<Record<string, CheckApiResponse[]>> = {};

/**
 * プロジェクトIDから審査対象一覧を取得（API形式）
 */
export function findCasesByProjectId(projectId: string): CaseApiResponse[] {
  return MOCK_CASES[projectId] ?? [];
}

/**
 * 審査対象IDから審査対象を取得（API形式）
 */
export function findCaseById(
  projectId: string,
  caseId: string,
): CaseApiResponse | undefined {
  const items = findCasesByProjectId(projectId);
  return items.find((item) => item.publicId === caseId);
}

/**
 * チェックリストのMockデータを生成（api-server準拠のレスポンス形式）
 */
function generateMockCheckList(summary: {
  files: boolean;
  fields: boolean;
  consistencies: boolean;
}): CheckApiResponse[] {
  const now = '2025-01-15T10:00:00.000Z';
  const checks: CheckApiResponse[] = [];

  // ファイルチェック項目
  checks.push(
    {
      publicId: 'check-file-001',
      checkType: 'file',
      checkKey: 'employment_contract',
      title: '雇用契約書がアップロードされているか',
      displayOrder: 1,
      aiValue: null,
      humanValue: null,
      aiResult: summary.files ? 'OK' : null,
      humanResult: null,
      reviewStatus: summary.files ? 'AiApproved' : null,
      evidences: summary.files
        ? [
            {
              evidenceFileId: 'evidence-file-001',
              fileName: '雇用契約書_山田太郎.pdf',
              page: 1,
              extractedValue: null,
              boundingBox: null,
            },
          ]
        : [],
      memo: '',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
    {
      publicId: 'check-file-002',
      checkType: 'file',
      checkKey: 'social_insurance_notification',
      title: '社会保険資格取得届がアップロードされているか',
      displayOrder: 2,
      aiValue: null,
      humanValue: null,
      aiResult: summary.files ? 'OK' : null,
      humanResult: null,
      reviewStatus: summary.files ? 'AiApproved' : null,
      evidences: summary.files
        ? [
            {
              evidenceFileId: 'evidence-file-002',
              fileName: '社会保険資格取得届_山田太郎.pdf',
              page: 1,
              extractedValue: null,
              boundingBox: null,
            },
          ]
        : [],
      memo: '',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
  );

  // スキャン（フィールド）チェック項目
  checks.push(
    {
      publicId: 'check-field-001',
      checkType: 'field',
      checkKey: 'employment_start_date',
      title: '雇用開始日が正しく読み取れているか',
      displayOrder: 3,
      aiValue: summary.fields ? '2024/04/01' : null,
      humanValue: null,
      aiResult: summary.fields ? 'OK' : null,
      humanResult: null,
      reviewStatus: summary.fields ? 'AiApproved' : null,
      evidences: summary.fields
        ? [
            {
              evidenceFileId: 'evidence-file-001',
              fileName: '雇用契約書_山田太郎.pdf',
              page: 1,
              extractedValue: '2024/04/01',
              boundingBox: { x: 100, y: 200, w: 80, h: 20 },
            },
          ]
        : [],
      memo: '',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
    {
      publicId: 'check-field-002',
      checkType: 'field',
      checkKey: 'salary_amount',
      title: '給与額が正しく読み取れているか',
      displayOrder: 4,
      aiValue: summary.fields ? '300000' : null,
      humanValue: null,
      aiResult: summary.fields ? 'OK' : 'NG',
      humanResult: null,
      reviewStatus: summary.fields ? 'AiApproved' : 'AiRejected',
      evidences: summary.fields
        ? [
            {
              evidenceFileId: 'evidence-file-001',
              fileName: '雇用契約書_山田太郎.pdf',
              page: 2,
              extractedValue: '300000',
              boundingBox: { x: 150, y: 300, w: 100, h: 20 },
            },
          ]
        : [],
      memo: summary.fields ? '' : '給与情報が読み取れませんでした',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
    {
      publicId: 'check-field-003',
      checkType: 'field',
      checkKey: 'social_insurance_number',
      title: '社会保険番号が正しく読み取れているか',
      displayOrder: 5,
      aiValue: summary.fields ? '1234567890' : null,
      humanValue: null,
      aiResult: summary.fields ? 'OK' : null,
      humanResult: null,
      reviewStatus: summary.fields ? 'AiApproved' : null,
      evidences: summary.fields
        ? [
            {
              evidenceFileId: 'evidence-file-002',
              fileName: '社会保険資格取得届_山田太郎.pdf',
              page: 1,
              extractedValue: '1234567890',
              boundingBox: { x: 120, y: 250, w: 90, h: 20 },
            },
          ]
        : [],
      memo: '',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
  );

  // 整合性チェック項目
  checks.push(
    {
      publicId: 'check-consistency-001',
      checkType: 'consistency',
      checkKey: 'employment_period_match',
      title: '雇用契約書と人件費総括表の雇用期間が一致しているか',
      displayOrder: 6,
      aiValue: summary.consistencies ? '2024/04/01 - 2025/03/31' : null,
      humanValue: null,
      aiResult: summary.consistencies ? 'OK' : 'NG',
      humanResult: null,
      reviewStatus: summary.consistencies ? 'AiApproved' : 'AiRejected',
      evidences: summary.consistencies
        ? [
            {
              evidenceFileId: 'evidence-file-001',
              fileName: '雇用契約書_山田太郎.pdf',
              page: 1,
              extractedValue: '2024/04/01 - 2025/03/31',
              boundingBox: { x: 100, y: 200, w: 80, h: 20 },
            },
            {
              evidenceFileId: 'evidence-file-002',
              fileName: '社会保険資格取得届_山田太郎.pdf',
              page: 1,
              extractedValue: '2024/04/01 - 2025/03/31',
              boundingBox: null,
            },
          ]
        : [],
      memo: summary.consistencies ? '' : '雇用期間と計上期間に不整合があります',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
    {
      publicId: 'check-consistency-002',
      checkType: 'consistency',
      checkKey: 'salary_amount_match',
      title: '給与額と人件費総括表の金額が一致しているか',
      displayOrder: 7,
      aiValue: summary.consistencies ? '300000' : null,
      humanValue: null,
      aiResult: summary.consistencies ? 'OK' : null,
      humanResult: null,
      reviewStatus: summary.consistencies ? 'AiApproved' : null,
      evidences: summary.consistencies
        ? [
            {
              evidenceFileId: 'evidence-file-001',
              fileName: '雇用契約書_山田太郎.pdf',
              page: 2,
              extractedValue: '300000',
              boundingBox: { x: 150, y: 300, w: 100, h: 20 },
            },
            {
              evidenceFileId: 'evidence-file-002',
              fileName: '社会保険資格取得届_山田太郎.pdf',
              page: 1,
              extractedValue: '300000',
              boundingBox: null,
            },
          ]
        : [],
      memo: '',
      mark: null,
      updatedByUser: { publicId: 'ai-user', email: 'ai@example.com' },
      updatedAt: now,
    },
  );

  return checks;
}

/**
 * 審査対象IDから審査対象詳細を取得（API形式）
 */
export function findCaseDetailById(
  projectId: string,
  caseId: string,
): CaseDetailApiResponse | undefined {
  const apiItem = findCaseById(projectId, caseId);
  if (!apiItem) return undefined;

  // 承認系 (ApprovedByHuman / ApprovedByAI) なら check 生成上は「問題なし」として扱う (Issue #376: 3 値化)
  const summary = {
    files: apiItem.summaryFiles !== 'Unapproved',
    fields: apiItem.summaryFields !== 'Unapproved',
    consistencies: apiItem.summaryConsistencies !== 'Unapproved',
  };

  const cacheKey = `${projectId}:${caseId}`;
  // キャッシュがなければ生成してキャッシュに格納
  MOCK_CHECK_LISTS[cacheKey] ??= generateMockCheckList(summary);

  return {
    ...apiItem,
    checks: MOCK_CHECK_LISTS[cacheKey],
  };
}

/**
 * チェック項目を一括更新（Mock）
 * api-server準拠: 更新後の CaseDetailApiResponse を返す
 */
export function updateChecks(
  projectId: string,
  caseId: string,
  checks: CheckUpdateApiRequest[],
): CaseDetailApiResponse | null {
  const cacheKey = `${projectId}:${caseId}`;
  const now = new Date();

  // キャッシュにチェックリストが存在する場合のみ更新
  if (MOCK_CHECK_LISTS[cacheKey]) {
    MOCK_CHECK_LISTS[cacheKey] = MOCK_CHECK_LISTS[cacheKey].map((check) => {
      const updateItem = checks.find((c) => c.publicId === check.publicId);
      if (!updateItem) return check;
      return {
        ...check,
        ...(updateItem.humanValue !== undefined && {
          humanValue: updateItem.humanValue,
        }),
        ...(updateItem.humanResult !== undefined && {
          humanResult: updateItem.humanResult,
        }),
        ...(updateItem.memo !== undefined && {
          // memo は string 型（null 廃止）のため null の場合は空文字に変換
          memo: updateItem.memo ?? '',
        }),
        ...(updateItem.mark !== undefined && { mark: updateItem.mark ?? null }),
        updatedAt: now.toISOString(),
        updatedByUser: {
          publicId: 'current-user',
          email: 'current-user@example.com',
        },
      };
    });
  }

  // api-server準拠: CaseDetailApiResponse を返す
  const item = findCaseDetailById(projectId, caseId);
  if (!item) return null;

  return {
    ...item,
    updatedAt: now.toISOString(),
  };
}

/**
 * 審査対象メタデータを更新（Mock）
 * mark/memo を更新し、成功した場合 true を返す
 */
export function updateCaseMetadata(
  projectId: string,
  caseId: string,
  body: unknown,
): boolean {
  const cases = MOCK_CASES[projectId] as CaseApiResponse[] | undefined;
  if (!cases) return false;

  const index = cases.findIndex((c) => c.publicId === caseId);
  if (index === -1) return false;

  const data = body as { mark?: string | null; memo?: string };
  const current = cases[index];
  cases[index] = {
    ...current,
    ...(data.mark !== undefined && {
      mark: data.mark as CaseApiResponse['mark'],
    }),
    ...(data.memo !== undefined && { memo: data.memo }),
    updatedAt: new Date().toISOString(),
  };

  return true;
}
